(function () {
    if($("#autocomplete").length > 0 ){

   
        // var locatorSection = document.getElementById("locator-input-section")
        var input = document.getElementById("autocomplete");
        var autocomplete = new google.maps.places.Autocomplete(input);
        $("#search_btn").click(function(){
            var place = autocomplete.getPlace();

            $.ajax({
                type: "post",
                url: baseUrl +"/display-search-info",
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: {"search_result":JSON.stringify(place)},
                success: function (data) {
                    $("#show_div").show();
                    $("#google_result").val(JSON.stringify(place));
                    $("#googlePlaceResult").html(data);
                },
            });

        });
     }

})();
